<template>
  <div class="school-application">
    <h1>院校申请</h1>
    <div class="service-category">留学服务</div>

    <section class="application-section">
      <div class="intro">
        <p>
          留学准备的第一步，就是要根据你的综合条件确定你的留学方向，即到哪所学校去学习？读哪个专业？无论你的经济能力大或小，只要具备一定基础，合理规划，都能找到适合自己的学校和专业，让美梦成真。面对众多的院校和专业该怎么选呢？必须要先了解不同学校的情况及专业才能够做出正确的选择。
        </p>
        <p>
          随着出国留学的热潮，赴加拿大留学人数不断增加，竞争也越来越激烈。同时加拿大名校也在不断提高自身录取要求，录取比例一再降低。要想进入心仪的学校，从前期时间规划、专业定位、语言考试、背景提升，到选校、文书包装以及办理签证等，申请过程中的每一步都需要倾尽全力。我们的申请服务团队成员具有多年的申请经验，会对每一个申请的学生进行一对一的个性化全程指导支持，尽最大努力帮助学生实现自己的梦想。
        </p>
      </div>

      <div class="services">
        <h2>我们的服务包括：</h2>
        <ul>
          <li>研究生及博士申请：
            <p>为您提供全面的研究生和博士课程申请指导，包括选校建议、材料准备等。</p>
          </li>
          <li>本科申请：
            <p>协助您完成本科课程的申请流程，包括学校选择、专业定位等。</p>
          </li>
          <li>中小学申请：
            <p>为计划就读加拿大中小学的学生提供全方位的申请服务。</p>
          </li>
        </ul>
      </div>

      <div class="process">
        <h2>申请流程</h2>
        <ol>
          <li>初步评估和规划</li>
          <li>选校和专业定位</li>
          <li>准备申请材料</li>
          <li>提交申请</li>
          <li>跟进申请进度</li>
          <li>获取录取通知</li>
          <li>签证申请</li>
        </ol>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SchoolApplicationView'
}
</script>

<style scoped lang="less">
.school-application {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;

  h1 {
    font-size: 32px;
    color: #333;
    margin-bottom: 10px;
  }

  .service-category {
    color: #666;
    font-size: 18px;
    margin-bottom: 30px;
  }

  .application-section {
    background: #fff;
    border-radius: 8px;
    padding: 30px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    .intro {
      p {
        margin-bottom: 20px;
        line-height: 1.8;
        color: #444;
      }
    }

    .services {
      margin-top: 40px;

      h2 {
        font-size: 24px;
        color: #333;
        margin-bottom: 20px;
      }

      ul {
        list-style: none;
        padding: 0;

        li {
          background: #f8f9fa;
          padding: 20px;
          margin-bottom: 15px;
          border-radius: 4px;
          transition: all 0.3s ease;

          &:hover {
            background: #e9ecef;
            transform: translateX(10px);
          }

          p {
            margin-top: 10px;
            color: #666;
            font-size: 14px;
          }
        }
      }
    }

    .process {
      margin-top: 40px;

      h2 {
        font-size: 24px;
        color: #333;
        margin-bottom: 20px;
      }

      ol {
        padding-left: 20px;

        li {
          margin-bottom: 15px;
          color: #555;
          line-height: 1.6;
          padding-left: 10px;
        }
      }
    }
  }
}
</style>